import React, { useEffect, useRef } from 'react';

import SubjectIcon from '@material-ui/icons/Subject';

import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineFormik from '../../../common/inline/InlineFormik';
import { useUpdateCapa } from '../Capa.hook';
import { Capa, BaseCapaCardProps } from '../Capa.interface';
import CapaDetailsCardContext from './CapaDetailsCardContext';

export interface CapaDetailsCardProps extends BaseCapaCardProps {
  capa: Capa;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
}

export const CapaDetailsCard: React.FC<CapaDetailsCardProps> = props => {
  const { capa, onChange, setErrorMessage, setSuccessMessage } = props;
  const onChangeRef = useRef(onChange);
  const [{ data: updatedCapa, isLoading, error }, update] = useUpdateCapa(
    capa.id
  );

  useEffect(() => {
    if (updatedCapa?.id) {
      setSuccessMessage('CAPA successfully updated');
      onChangeRef.current?.(updatedCapa);
    }
  }, [setSuccessMessage, updatedCapa]);

  useEffect(() => {
    if (Boolean(error)) setErrorMessage('There was an error saving');
  }, [setErrorMessage, error]);

  if (!capa.id) return null;
  return (
    <InlineFormik
      initialValues={
        {
          ...capa,
          capaOwner: capa.capaOwner?.id || '',
          investigator: capa.investigator?.id || ''
        } as any
      }
      isSubmitting={isLoading}
      error={error}
      onSubmit={(updatedValue: Partial<Capa>) => {
        update(updatedValue);
      }}
    >
      <Card>
        <CardTitle>
          <SubjectIcon />
          Details
        </CardTitle>
        <CardContent padding='large'>
          <CapaDetailsCardContext {...props} />
        </CardContent>
      </Card>
    </InlineFormik>
  );
};

export default CapaDetailsCard;
